import Crud from './crud'
import client from '@/services/client'

export default class SiteTenantService extends Crud {
  constructor (siteId) {
    super(`/site/${siteId}/tenant`)
    this.siteId = siteId
  }

  filter (query, params) {
    return client.post('/api/site/tenant/filter', query, params)
  }

  getForSelect () {
    return client.get(`/api/site/${this.siteId}/tenant/select`)
  }
}
